module.exports = __webpack_public_path__ + "static/8-eb8e902a5e46381726036a02eac4d922.svg";